var map = {
	"./ar.json": 4784,
	"./ar/index.json": 1875,
	"./bn.json": 9227,
	"./bn/index.json": 1976,
	"./de.json": 5180,
	"./de/index.json": 9871,
	"./el.json": 8954,
	"./el/index.json": 765,
	"./en.json": 968,
	"./en/index.json": 9291,
	"./es.json": 2975,
	"./es/index.json": 9052,
	"./fil.json": 250,
	"./fil/index.json": 3069,
	"./fr.json": 1979,
	"./fr/index.json": 920,
	"./hi.json": 9668,
	"./hi/index.json": 2727,
	"./id.json": 4902,
	"./id/index.json": 3545,
	"./it.json": 3110,
	"./it/index.json": 7561,
	"./ja.json": 7446,
	"./ja/index.json": 1353,
	"./ko.json": 2237,
	"./ko/index.json": 594,
	"./pl.json": 5459,
	"./pl/index.json": 1632,
	"./pt.json": 875,
	"./pt/index.json": 5320,
	"./ru.json": 690,
	"./ru/index.json": 4805,
	"./sw.json": 2365,
	"./sw/index.json": 3106,
	"./th.json": 427,
	"./th/index.json": 4520,
	"./tr.json": 6829,
	"./tr/index.json": 3186,
	"./vi.json": 2850,
	"./vi/index.json": 3461,
	"./zh.json": 2793,
	"./zh/index.json": 6590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9759;